export const defaultSections = [
  {
    id: 1,
    title: "వ్యక్తిగత వివరాలు",
    fields: [
      { id: 1, label: "పేరు", value: "పేరు నమోదు చేయండి" },
      { id: 2, label: "పుట్టిన రోజు", value: "పుట్టిన రోజు చేయండి" },
      { id: 3, label: "రంగు", value: "రంగును తెలుపండి" },
      { id: 4, label: "ఎత్తు", value: "ఎత్తును తెలుపండి" },
      { id: 5, label: "వృత", value: "వృత్తి వివరం తెలుపండి" },
      { id: 6, label: "ఆదాయం", value: "ఆదాయ వివరం తెలుపండి" },
      { id: 7, label: "విద్య", value: "విద్యార్హత తెలియజేయండి" }
    ]
  },
  {
    id: 2,
    title: "కుటుంబ వివరాలు",
    fields: [
      { id: 8, label: "తండ్రి పేరు", value: "తండ్రి పేరు తెలుపండి" },
      { id: 9, label: "తండ్రి వృత్తి", value: "తండ్రి వృత్తి తెలుపండి" },
      { id: 10, label: "తల్లి పేరు", value: "తల్లి పేరు తెలుపండి" },
      { id: 11, label: "తల్లి వృత్తి", value: "తల్లి వృత్తి తెలుపండి" }
    ]
  },
  {
    id: 3,
    title: "సంప్రదించాల్సిన వివరాలు",
    fields: [
      { id: 12, label: "పేరు", value: "పేరు నమోదు చేయండి" },
      { id: 13, label: "సంప్రదించాల్సిన నెంబర", value: "సంప్రదించాల్సిన నెంబరు తెలుపండి" },
      { id: 14, label: "ఇంటి చిరునామా", value: "ఇంటి చిరునామా తెలియజేయండి" }
    ]
  }
];




